import { useAtomValue } from 'jotai';
import { Local } from '@/model';
import { Lang, getLocalByLang } from '@/i18n/i18n';

export function useCurrentLang() {
    const langType = useAtomValue(Local.langType);
    return getLocalByLang.get(langType || Lang.zh_CN);
}
